import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M17.772 13.418a1.52 1.52 0 0 0-1.52-1.519H7.743c-.838 0-1.518.68-1.518 1.519v4.538c0 .839.68 1.52 1.518 1.52h8.509c.839 0 1.52-.681 1.52-1.52zm-6.525 2.837V15.12a.75.75 0 0 1 1.5 0v1.135a.75.75 0 0 1-1.5 0m3.687-8.792a2.937 2.937 0 1 0-5.874 0v2.936h5.874zm1.5 2.942a3.02 3.02 0 0 1 2.837 3.013v4.538a3.02 3.02 0 0 1-3.019 3.02H7.743a3.02 3.02 0 0 1-3.018-3.02v-4.538a3.02 3.02 0 0 1 2.835-3.013V7.463a4.438 4.438 0 0 1 8.874 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }